// extracted by mini-css-extract-plugin
export default {"distributionContainer":"vn2gG","container":"P11WK","ratingBar":"PR36S","count":"mRPxW","progress":"XZ6TK","selectContainer":"tCQpd","rating":"r6UXx","ratingFocus":"i5wck"};